import { useContext } from "react";
import { StoreContext } from "../context/storeProvider";

export default function useStore() {
  return useContext(StoreContext);
}
